import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Tianjia"
});
const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_569_46632)"><path d="M9 16.5001C13.1421 16.5001 16.5 13.1423 16.5 9.00012C16.5 4.85798 13.1421 1.50012 9 1.50012C4.85786 1.50012 1.5 4.85798 1.5 9.00012C1.5 13.1423 4.85786 16.5001 9 16.5001Z" fill="#EFF1F7" stroke="#EFF1F7" stroke-width="1.5"></path><path d="M9 6.00012V12.0001" stroke="#737E99" stroke-width="1.5" stroke-linecap="square"></path><path d="M6 9H12" stroke="#737E99" stroke-width="1.5" stroke-linecap="square"></path></g><defs><clipPath id="clip0_569_46632"><rect width="18" height="18" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var tianjia = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { tianjia as default };
